import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { SocialType } from 'sections/Company/ContactUs/types';
import { Numbers } from 'sections/Company/ContactUs/components/Contact/Numbers';
import styles from 'sections/Company/ContactUs/components/Contact/Info/Info.module.scss';

const cn = classNames.bind(styles);

interface InfoProps {
  social: SocialType;
  visible: boolean;
}

const Info: FC<InfoProps> = ({ social, visible }): React.ReactElement => {
  const socialElements = Object.entries(social).map(([key, value], index) => {
    return (
      <li
        className={cn('social__item')}
        key={`${value}_${index}`}
      >
        <a className={cn('social__link')} href={value}>
          <img
            src={`/images/pages/Company/ContactUs/${key}.svg`}
            alt={`${key} icon`}
          />
        </a>
      </li>
    );
  });

  return (
    <div className={cn('info')}>
      <h2 className={cn('info__heading')}>We always answer!</h2>

      {visible && (
        <div className={cn('info__content')}>
          <div className={cn('info__location')}>
            <img
              src='/images/pages/Company/ContactUs/icon-geolocation.svg'
              alt='Geolocation icon'
            />
            <a
              className={cn('info__location-link')}
              target='_blank'
              rel='noopener noreferrer'
              href='https://goo.gl/maps/ofNXErEtcDZWH6xr9'
            >
              P.O.Box 17000 | 409 Jafza 17, Dubai, United Arab Emirates
            </a>
          </div>

          <Numbers />
        </div>
      )}

      <ul className={cn('social')}>{socialElements}</ul>
    </div>
  );
};

export { Info };
